import React, { useEffect, useState } from "react";
import { createClasses } from "@bloomberg/media-ui-core";
import { useRegUIClient } from "@foundation/reg-ui-client";
import styles from "./styles.module.css";
import Modal from "~components/Modal";
import DeleteForm from "~components/Portfolio/DeleteForm";
import PortfolioForm from "~components/Portfolio/PortfolioForm";
import { FORM_ACTION } from "~constants/Portfolio";
import { deletePortfolioById } from "~api/portfolio/portfolioData";
import { usePortfolioPage } from "~context/PortfolioPageContext";
import { PortfolioFormValidationProvider } from "~context/PortfolioFormValidationContext";

type PortfolioFormModal = {
  open: boolean;
  onClose: () => void;
  portfolioId: number;
  portfolioName: string;
};

export default function PortfolioFormModal(props: PortfolioFormModal) {
  const { open, onClose, portfolioId, portfolioName } = props;

  const [modalOpen, setModalOpen] = useState(open);
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);

  const { removePortfolio } = usePortfolioPage();
  const { session } = useRegUIClient();
  const bconnectId = session?.userInfo?.userId ?? "";

  useEffect(() => {
    setModalOpen(open);
  }, [open]);

  const formClass = createClasses({
    [styles.formHidden]: showDeleteConfirmation,
  });

  const handleFormEvent = async (action: string) => {
    switch (action) {
      case FORM_ACTION.CANCEL:
        if (showDeleteConfirmation) {
          // hide delete confirmation
          setShowDeleteConfirmation(false);
        } else {
          // close modal
          onClose();
        }
        break;
      case FORM_ACTION.DELETE:
        // ask for delete confirmation
        setShowDeleteConfirmation(true);
        break;
      case FORM_ACTION.DELETE_PERMANENTLY:
        // user confirms delete
        // delete portfolio and refresh portfolio tabs

        // delete portfolio
        await deletePortfolioById(bconnectId, portfolioId);

        // remove portfolio from context
        removePortfolio(portfolioId);

        // close modal and refresh tabs
        onClose();

        setShowDeleteConfirmation(false);
        break;
    }
  };

  return (
    <PortfolioFormValidationProvider>
      <Modal open={modalOpen} onClose={onClose} closeOnOutsideClick={true}>
        <div className={formClass}>
          <PortfolioForm
            portfolioId={portfolioId}
            onFormEvent={handleFormEvent}
          />
        </div>
        {showDeleteConfirmation && (
          <DeleteForm
            portfolioName={portfolioName}
            onFormEvent={handleFormEvent}
          />
        )}
      </Modal>
    </PortfolioFormValidationProvider>
  );
}
